import { memo, useCallback, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import Actions from "./Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import SelectItemSheet, {
  Item,
} from "@coworker/apprestructured/src/task-management/components/SelectItemSheet/SelectItemSheet";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";

const items: Item[] = [
  {
    label: "Item 1",
    value: "item1",
  },
  {
    label: "Item 2",
    value: "item2",
  },
  {
    label: "Item 3",
    value: "item3",
  },
];

function SelectItemSheetDemo() {
  const [itemValue, setItemValue] = useState<string>("");
  const [title, setTitle] = useState<string>("Title");
  const [open, setOpen] = useState(false);
  const [emphasised, setEmphasised] = useState(false);

  const handleCloseClick = useCallback(() => {
    setItemValue("");
    setOpen(false);
  }, []);

  return (
    <Demo>
      <Name>SelectItemSheetDemo</Name>
      <Highlight>
        <FixaButton type="tertiary" onClick={() => setOpen(true)}>
          Open
        </FixaButton>
        <SelectItemSheet
          visible={open}
          items={items}
          itemValue={itemValue}
          title={title}
          emphasised={emphasised}
          onItemValueChange={setItemValue}
          onCloseClick={handleCloseClick}
          onConfirmClick={() => {
            alert("onConfirmClick");
          }}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          type="text"
          label="title"
        />
        <FixaCheckbox
          label="emphasised"
          value="SelectItemSheet-emphasised"
          id="SelectItemSheet-emphasised"
          checked={emphasised}
          onChange={() => setEmphasised((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(SelectItemSheetDemo);
